import React, { useContext, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import GlobalPkgCard from "../cards/GlobalPkgCard";
import NavBelt from "../page-essentials/NavBelt";
// import TestReponsive from "../page-essentials/TestReponsive";
import { GlobalPkgBreadCrumpData } from "../static-data/breadcrump";
import LangContext from "../../context/LangContext";
import PackagesService from "../../services/Packages.service";
import { IPackage } from "../../types/global";
import SocialMedia from "../page-essentials/SocialMedia";
import BookNowBanner from "../page-components/home/BookNowBanner";
import FeedbackFromClients from "../page-components/home/FeedbackFromClients";
import TripAdvisorLogo from "../../resources/images/TripAdvisor_Logo.svg.png";
import ShareButtons from "../page-essentials/ShareButtons";
import WhyToBookCard from "../cards/WhyToBookCard";
import TripAdvisorImgCard from "../cards/TripAdvisorImgCard";

const GlobalPackages: React.FC = () => {
  const [data, setData] = useState<IPackage[]>([]);
  const [total, setTotal] = useState<number>();
  const { lang_id } = useContext(LangContext);

  const [searchParams] = useSearchParams();
  const pkgCategory = searchParams.get("pkgCategory");

  const fetchPackages = async (pkgCategory: string) => {
    try {
      const res = await PackagesService.fetchPackages(
        pkgCategory,
        lang_id,
        false
      );
      console.log(res);
      setData(res.data.data[0]);
      setTotal(res.data.data[1]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (pkgCategory && lang_id) {
      fetchPackages(pkgCategory);
    }
  }, [pkgCategory, lang_id]);

  return (
    <div>
      <NavBelt
        page="Trek au Népal"
        img="https://images.unsplash.com/photo-1618413516603-d33a4e56c8a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80"
        breadCrumpInfo={GlobalPkgBreadCrumpData}
      />
      {/* <TestReponsive /> */}
      <div className="container mx-auto px-4 lg:px-8 2xl:px-12 my-8">
        {/* starts  */}
        <div className="">
          <div className="flex justify-between">
            <div className="">
              <h1 className="text-3xl font-bold text-primary-base">
                {data[0]?.pkg_destination_category?.pkg_destination_category}
              </h1>
              <p className="mt-4 font-semibold text-xl">About</p>
            </div>
            <p className="">
              <span className="font-semibold">{total}</span> Total packages |{" "}
              <span className="text-primary-base">Nepal</span>
            </p>
          </div>
          <hr className="my-2" />

          <div className="grid lg:grid-cols-12 my-7 gap-16">
            <div
              className="lg:col-span-8 prose lg:prose-xl prose-p:text-[1.2rem] max-w-full"
              dangerouslySetInnerHTML={{
                __html:
                  data[0]?.pkg_destination_category.translations[0].description,
              }}
            ></div>
            <div className="hidden lg:block lg:col-span-4 space-y-8 sticky top-8">
              <TripAdvisorImgCard />
              <div className="shadow-lg p-8 rounded-lg">
                <WhyToBookCard />
              </div>

              <div className="shadow-lg p-8 rounded -lg">
                <p className="font-semibold text-primary-base">
                  Share{" "}
                  {data[0]?.pkg_destination_category?.pkg_destination_category}
                </p>
                <ShareButtons />
              </div>
            </div>
          </div>
        </div>

        <hr className="my-6" />
        <div className="block lg:hidden">
          <TripAdvisorImgCard />
        </div>
        {/* card section  */}
        <div className="my-8">
          <h1 className="font-bold text-2xl text-primary-base">
            Available Pacakges
          </h1>
        </div>
        <div className="grid md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 gap-8 2xl:gap-16">
          {data.map((item, i) => (
            <GlobalPkgCard key={i} data={item} />
          ))}
        </div>

        <div className="my-8">
          {/* <FeedbackFromClients className="bg-gray-50" /> */}
          <BookNowBanner />
          <div className="my-4 lg:hidden">
            <WhyToBookCard />
            <div className="shadow-lg p-8 rounded-lg">
              <p className="font-semibold text-primary-base">
                Share{" "}
                {data[0]?.pkg_destination_category?.pkg_destination_category}
              </p>
              <ShareButtons />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalPackages;
